export const Chevron = ({
  isOpen,
  hasSubItems,
  isCollapsed,
}: {
  isOpen?: boolean
  hasSubItems: boolean
  isCollapsed?: boolean
}) => {
  if (!hasSubItems || isCollapsed) return null

  return isOpen ? <ChevronUp /> : <ChevronDown />
}

const ChevronUp = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="color-body-default"
  >
    <path d="M5.60156 2.60156C5.8125 2.39062 6.16406 2.39062 6.375 2.60156L10.8984 7.10156C11.1094 7.33594 11.1094 7.6875 10.8984 7.89844C10.6641 8.13281 10.3125 8.13281 10.1016 7.89844L6 3.79688L1.89844 7.89844C1.66406 8.13281 1.3125 8.13281 1.10156 7.89844C0.867188 7.6875 0.867188 7.33594 1.10156 7.125L5.60156 2.60156Z" />
  </svg>
)

const ChevronDown = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="color-body-default"
  >
    <path d="M5.60156 9.39844L1.10156 4.89844C0.867188 4.6875 0.867188 4.33594 1.10156 4.10156C1.3125 3.89062 1.66406 3.89062 1.89844 4.10156L6 8.22656L10.1016 4.125C10.3125 3.89062 10.6641 3.89062 10.8984 4.125C11.1094 4.33594 11.1094 4.6875 10.8984 4.89844L6.375 9.39844C6.16406 9.63281 5.8125 9.63281 5.60156 9.39844Z" />
  </svg>
)
